import { FC } from "react";
import { hasArrayElements } from "@/apiUtils/commonUtils";

interface StructuredDataProps {
  schemaMarkups: Array<Record<string, any>>;
}

const StructuredData: FC<StructuredDataProps> = ({ schemaMarkups }) => {
    return hasArrayElements(schemaMarkups)
    ? schemaMarkups.map((markup, index) => (
        <script key={`script-${index + 1}`} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(markup) }} />
      ))
    : "";
};

export default StructuredData;
